// extracted by mini-css-extract-plugin
export default {"form":"Create_form__vFwZ0","mimage":"Create_mimage__67BYe","fsview":"Create_fsview__G5uFX","fsheading":"Create_fsheading__CkDub","fstagline":"Create_fstagline__bbS7O"};